import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsReportsRoute: InvariantJiraRoute = {
	name: 'assets-reports-default-redirect',
	path: '/jira/assets/reports',
	exact: true,
};
